import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class AdvancedCommandClass {
    constructor(
        id = '',
        accountId = '',
        description = '',
        register = new Date()?.toISOString(),
        status = false,
    ) {
        this.id = id;
        this.accountId = accountId;
        this.description = description;
        this.register = register;
        this.status = status;
    }

    static getClassName = () => {
        return 'Advanced command - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName(), })?.result) {
            return new AdvancedCommandClass(
                obj?.id,
                obj?.accountId,
                obj?.description,
                obj?.register,
                obj?.status,
            );
        } else {
            return new AdvancedCommandClass();
        }
    }
}